<template>
  <el-dialog title="编辑" :visible.sync="formVisible" width="600px" :close-on-click-modal="false">
    <el-form ref="dataForm" :rules="formRules" :model="form" label-position="right" size="small" label-width="120px">
      <el-form-item label="类型名称" prop="name">
        <el-input v-model="form.name" placeholder="请输入类型名称" />
      </el-form-item>
      <el-form-item label="业绩标准" prop="kpiMoney">
        <el-input v-model="form.kpiMoney" placeholder="请输入业绩最低标准" />
      </el-form-item>
      <el-form-item label="状态" prop="state">
        <el-switch v-model="form.state" :active-value="1" :inactive-value="0"></el-switch>{{form.state?'启用':'禁用'}}
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="formVisible = false">
        取消
      </el-button>
      <el-button type="primary" @click="doCreate()">
        确认
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import customerClassifyApi from '@/api/config/customerClassify'
function initFormBean() {
  const formBean = {
    name: null,
    kpiMoney: null,
    state: 0,
  }
  return formBean
}

export default {
  data() {
    return {
      form: initFormBean(),
      formVisible: false,
      formRules: {
        name: [{ required: true, message: '请输入类型名称', trigger: 'blur' }],
        kpiMoney: [{ required: true, message: '请输入业绩最低标准', trigger: 'blur' }],
        state: [{ required: true, message: '请选择状态', trigger: 'change' }],
      },
      isRepSub: false,
    }
  },
  created() {
  },
  methods: {
    /**
     * 重置表单
     */
    resetForm() {
      this.form = initFormBean()
    },
    /**
     * 打开新建表单
     */
    handleCreate(row) {
      this.resetForm()
      this.formVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    handleUpdate(row) {
      this.resetForm()
      this.form = { ...row }
      this.formVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    /**
     * 执行新建操作
     */
    doCreate() {

      this.$refs["dataForm"].validate((valid) => {
        if (valid) {
          if (this.isRepSub) return
          this.isRepSub = true
          if (this.form.id > 0) {
            customerClassifyApi.update(this.form).then((data) => {
              this.postCallback(data)
            }).catch(res => {
              this.isRepSub = false
            });
          } else {
            customerClassifyApi.create(this.form).then((data) => {
              this.postCallback(data)
            }).catch(res => {
              this.isRepSub = false
            });
          }
        }
      });
    },
    postCallback(response) {
      this.isRepSub = false
      this.$message.success('操作成功')
      this.formVisible = false;
      this.$emit('created')
    },
  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-select {
  width: 100%;
}
</style>
